import { render, staticRenderFns } from "./dashboard_side.vue?vue&type=template&id=01ca45b4&scoped=true&"
import script from "./dashboard_side.vue?vue&type=script&lang=js&"
export * from "./dashboard_side.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_side.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dashboard_side.vue?vue&type=style&index=1&id=01ca45b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca45b4",
  null
  
)

export default component.exports